// src/pages/Signup.jsx 
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import ApiService from '../services/apiService';

const Signup = () => {
  const navigate = useNavigate();

  
  const [formData, setFormData] = useState({
    UserName: '',
    profession: '',
    mobileno: '',
    email: '',
    password: '',
    confirmPassword: '',
    city: '',
    state: '',
    acode: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.UserName.trim()) {
      newErrors.UserName = 'Name is required';
    }

    if (!formData.mobileno.trim()) {
      newErrors.mobileno = 'Mobile No is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters long';
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    if (!formData.city.trim()) {
      newErrors.city = 'City is required';
    }

    if (!formData.state.trim()) {
      newErrors.state = 'State is required';
    }

    if (!agreeToTerms) {
      newErrors.agreeToTerms = 'You must agree to the terms and conditions';
    }

    return newErrors;
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    setErrors({});

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);

    try {
      const registrationData = {
        username: formData.email,
        password: formData.password,
        name: formData.UserName,
        mobileNo: formData.mobileno,
        email: formData.email,
        city: formData.city,
        state: formData.state,
        acode: formData.acode,
        profession: formData.profession
      };

      console.log('🚀 Attempting user registration...');

      const result = await ApiService.registerUser(registrationData);

      console.log('✅ Registration successful:', result);

      alert('Registration successful! Please login with your credentials.');

      navigate('/login');

    } catch (error) {
      console.error('❌ Registration error:', error);

      if (error.message.includes('already exists') || error.message.includes('duplicate')) {
        setErrors({ email: 'An account with this email already exists' });
      } else if (error.message.includes('password')) {
        setErrors({ password: error.message });
      } else {
        setErrors({ general: error.message || 'Registration failed. Please try again.' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <>
      <Header />
      <div className="modern-signup-page">
        {/* Left Side - Signup Form */}
        <div className="signup-left-panel">
          <div className="signup-form-container">
            {/* Logo */}
            {/* <div className="signup-logo">
              <div className="logo-icon">
                <i className="bx bx-book-content"></i>
              </div>
              <h2 className="logo-text">LjSoft Online</h2>
            </div> */}

            {/* Form */}
            <div className="signup-form-content">
              <h1 className="signup-title">Create your account</h1>
              <p className="signup-subtitle">Join LjSoft Online and start your journey today</p>

              {/* Error Alert */}
              {errors.general && (
                <div className="error-alert">
                  <i className="bx bx-error-circle"></i>
                  <span>{errors.general}</span>
                </div>
              )}

              <form onSubmit={handleSignup} className="signup-form">
                {/* Name Field */}
                <div className="form-field">
                  <label className="field-label">Full Name</label>
                  <div className="input-wrapper">
                    <i className="bx bx-user input-icon"></i>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter your full name"
                      name="UserName"
                      value={formData.UserName}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </div>
                  {errors.UserName && (
                    <span className="field-error">
                      <i className="bx bx-error-circle"></i>
                      {errors.UserName}
                    </span>
                  )}
                </div>

                {/* Mobile & Profession Row */}
                <div className="form-row">
                  <div className="form-field">
                    <label className="field-label">Mobile Number</label>
                    <div className="input-wrapper">
                      <i className="bx bx-phone input-icon"></i>
                      <input
                        type="tel"
                        className="form-input"
                        placeholder="Mobile number"
                        name="mobileno"
                        value={formData.mobileno}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                    </div>
                    {errors.mobileno && (
                      <span className="field-error">
                        <i className="bx bx-error-circle"></i>
                        {errors.mobileno}
                      </span>
                    )}
                  </div>

                  <div className="form-field">
                    <label className="field-label">Profession</label>
                    <div className="input-wrapper">
                      <i className="bx bx-briefcase input-icon"></i>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Your profession"
                        name="profession"
                        value={formData.profession}
                        onChange={handleInputChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                </div>

                {/* Email Field */}
                <div className="form-field">
                  <label className="field-label">Email Address</label>
                  <div className="input-wrapper">
                    <i className="bx bx-envelope input-icon"></i>
                    <input
                      type="email"
                      className="form-input"
                      placeholder="Enter your email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </div>
                  {errors.email && (
                    <span className="field-error">
                      <i className="bx bx-error-circle"></i>
                      {errors.email}
                    </span>
                  )}
                </div>

                {/* Password Fields Row */}
                <div className="form-row">
                  <div className="form-field">
                    <label className="field-label">Password</label>
                    <div className="input-wrapper">
                      <i className="bx bx-lock-alt input-icon"></i>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-input"
                        placeholder="Create password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                      <button
                        type="button"
                        className="password-toggle-btn"
                        onClick={() => setShowPassword(!showPassword)}
                        disabled={isLoading}
                      >
                        <i className={showPassword ? 'bx bx-hide' : 'bx bx-show'}></i>
                      </button>
                    </div>
                    {errors.password && (
                      <span className="field-error">
                        <i className="bx bx-error-circle"></i>
                        {errors.password}
                      </span>
                    )}
                  </div>

                  <div className="form-field">
                    <label className="field-label">Confirm Password</label>
                    <div className="input-wrapper">
                      <i className="bx bx-lock-alt input-icon"></i>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        className="form-input"
                        placeholder="Confirm password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                      <button
                        type="button"
                        className="password-toggle-btn"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        disabled={isLoading}
                      >
                        <i className={showConfirmPassword ? 'bx bx-hide' : 'bx bx-show'}></i>
                      </button>
                    </div>
                    {errors.confirmPassword && (
                      <span className="field-error">
                        <i className="bx bx-error-circle"></i>
                        {errors.confirmPassword}
                      </span>
                    )}
                  </div>
                </div>

                {/* City & State Row */}
                <div className="form-row">
                  <div className="form-field">
                    <label className="field-label">City</label>
                    <div className="input-wrapper">
                      <i className="bx bx-building input-icon"></i>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Your city"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                    </div>
                    {errors.city && (
                      <span className="field-error">
                        <i className="bx bx-error-circle"></i>
                        {errors.city}
                      </span>
                    )}
                  </div>

                  <div className="form-field">
                    <label className="field-label">State</label>
                    <div className="input-wrapper">
                      <i className="bx bx-map input-icon"></i>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Your state"
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                    </div>
                    {errors.state && (
                      <span className="field-error">
                        <i className="bx bx-error-circle"></i>
                        {errors.state}
                      </span>
                    )}
                  </div>
                </div>

                {/* Sales Code Field */}
                <div className="form-field">
                  <label className="field-label">Sales Code (Optional)</label>
                  <div className="input-wrapper">
                    <i className="bx bx-barcode input-icon"></i>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter sales code"
                      name="acode"
                      value={formData.acode}
                      onChange={handleInputChange}
                      disabled={isLoading}
                    />
                  </div>
                </div>

                {/* Terms Checkbox */}
                <div className="terms-section">
                  <label className="terms-checkbox">
                    <input
                      type="checkbox"
                      checked={agreeToTerms}
                      onChange={(e) => setAgreeToTerms(e.target.checked)}
                      disabled={isLoading}
                    />
                    <span className="checkbox-custom"></span>
                    <span className="terms-text">
                      I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
                    </span>
                  </label>
                  {errors.agreeToTerms && (
                    <span className="field-error">
                      <i className="bx bx-error-circle"></i>
                      {errors.agreeToTerms}
                    </span>
                  )}
                </div>

                {/* Signup Button */}
                <button
                  type="submit"
                  className="signup-btn"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner"></span>
                      <span>Creating Account...</span>
                    </>
                  ) : (
                    <>
                      <span>Create Account</span>
                      <i className="bx bx-right-arrow-alt"></i>
                    </>
                  )}
                </button>
              </form>

              {/* Login Link */}
              <div className="login-section">
                <p>Already have an account?</p>
                <button onClick={handleLoginRedirect} className="login-link" disabled={isLoading}>
                  Sign In
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Gradient Background */}
        <div className="signup-right-panel">
          <div className="gradient-content">
            {/* Decorative Elements */}
            <div className="gradient-decoration decoration-1"></div>
            <div className="gradient-decoration decoration-2"></div>
            <div className="gradient-decoration decoration-3"></div>

            {/* Content */}
            <div className="gradient-text-content">
              <div className="welcome-badge">
                <i className="bx bx-rocket"></i>
                <span>Get Started</span>
              </div>
              
              <h2 className="gradient-title">
                Welcome to<br/>LjSoft Online
              </h2>
              
              <p className="gradient-description">
                Your Complete Legal Research Platform
              </p>

              {/* Benefits */}
              <div className="benefit-list">
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="bx bx-check"></i>
                  </div>
                  <div className="benefit-text">
                    <h4>Free Trial</h4>
                    <p>Register Now</p>
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="bx bx-check"></i>
                  </div>
                  <div className="benefit-text">
                    <h4>No Credit Card</h4>
                    <p>Sign up without payment details</p>
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="bx bx-check"></i>
                  </div>
                  <div className="benefit-text">
                    <h4>Instant Access</h4>
                    <p>Start researching immediately</p>
                  </div>
                </div>
              </div>

              {/* Illustration */}
              <div className="signup-illustration">
                <i className="bx bx-user-plus"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`

      /* ============================================
     REMOVE TOP WHITE SPACE - ADD THIS FIRST
  ============================================ */
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  html {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* ============================================
     MODERN SIGNUP PAGE
  ============================================ */
  .modern-signup-page {
    display: flex;
    min-height: calc(100vh - 80px);
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
      

        /* ============================================
           LEFT PANEL - SIGNUP FORM
        ============================================ */
        .signup-left-panel {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          background: #ffffff;
          overflow-y: auto;
        }

        .signup-form-container {
          width: 100%;
          max-width: 600px;
          animation: slideInLeft 0.6s ease;
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* Logo */
        .signup-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 32px;
        }

        .logo-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          background: linear-gradient(135deg, #E91E63, #c41849);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 24px;
        }

        .logo-text {
          font-size: 28px;
          font-weight: 800;
          background: linear-gradient(135deg, #E91E63, #c41849);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin: 0;
        }

        /* Form Content */
        .signup-form-content {
          width: 100%;
        }

        .signup-title {
          font-size: 32px;
          font-weight: 800;
          color: #1a1a1a;
          margin-bottom: 8px;
        }

        .signup-subtitle {
          font-size: 15px;
          color: #666;
          margin-bottom: 28px;
        }

        /* Error Alert */
        .error-alert {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 14px 16px;
          background: #fee;
          border: 1px solid #fcc;
          border-radius: 12px;
          color: #c33;
          font-size: 14px;
          margin-bottom: 20px;
          animation: shake 0.4s ease;
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }

        .error-alert i {
          font-size: 20px;
        }

        /* Form Fields */
        .signup-form {
          display: flex;
          flex-direction: column;
          gap: 18px;
          margin-bottom: 20px;
        }

        .form-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .field-label {
          font-size: 13px;
          font-weight: 600;
          color: #333;
        }

        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          left: 14px;
          font-size: 18px;
          color: #999;
          pointer-events: none;
        }

        .form-input {
          width: 100%;
          padding: 12px 14px 12px 44px;
          border: 2px solid #e0e0e0;
          border-radius: 10px;
          font-size: 14px;
          color: #333;
          background: #fafafa;
          transition: all 0.3s ease;
        }

        .form-input:focus {
          outline: none;
          border-color: #E91E63;
          background: white;
          box-shadow: 0 0 0 4px rgba(245, 166, 35, 0.1);
        }

        .form-input::placeholder {
          color: #999;
        }

        .form-input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .password-toggle-btn {
          position: absolute;
          right: 14px;
          background: transparent;
          border: none;
          color: #999;
          font-size: 18px;
          cursor: pointer;
          padding: 4px;
          transition: color 0.3s ease;
        }

        .password-toggle-btn:hover {
          color: #E91E63;
        }

        .field-error {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: #c33;
          margin-top: 2px;
        }

        .field-error i {
          font-size: 14px;
        }

        /* Terms Section */
        .terms-section {
          margin: 8px 0;
        }

        .terms-checkbox {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          cursor: pointer;
          position: relative;
        }

        .terms-checkbox input[type="checkbox"] {
          position: absolute;
          opacity: 0;
          cursor: pointer;
        }

        .checkbox-custom {
          width: 20px;
          height: 20px;
          border: 2px solid #e0e0e0;
          border-radius: 6px;
          background: #fafafa;
          flex-shrink: 0;
          position: relative;
          transition: all 0.3s ease;
        }

        .terms-checkbox input[type="checkbox"]:checked ~ .checkbox-custom {
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-color: #E91E63;
        }

        .terms-checkbox input[type="checkbox"]:checked ~ .checkbox-custom::after {
          content: '✓';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 12px;
          font-weight: bold;
        }

        .terms-text {
          font-size: 13px;
          color: #666;
          line-height: 1.5;
        }

        .terms-text a {
          color: #E91E63;
          text-decoration: none;
          font-weight: 500;
        }

        .terms-text a:hover {
          color: #c41849;
        }

        /* Signup Button */
        .signup-btn {
          width: 100%;
          padding: 15px;
          background: linear-gradient(135deg, #E91E63, #c41849);
          border: none;
          border-radius: 12px;
          color: white;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
          margin-top: 12px;
        }

        .signup-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, #E91E64, #F5316D);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(245, 166, 35, 0.4);
        }

        .signup-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .signup-btn i {
          font-size: 20px;
        }

        .spinner {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Login Section */
        .login-section {
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid #e0e0e0;
        }

        .login-section p {
          font-size: 14px;
          color: #666;
          margin-bottom: 8px;
        }

        .login-link {
          background: transparent;
          border: none;
          color: #E91E63;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .login-link:hover {
          color: #c41849;
        }

        /* ============================================
           RIGHT PANEL - GRADIENT BACKGROUND
        ============================================ */
        .signup-right-panel {
          flex: 1;
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 50%, #c41849 100%);
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .gradient-content {
          position: relative;
          z-index: 1;
          padding: 60px 40px;
          text-align: center;
          animation: slideInRight 0.8s ease;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* Decorations */
        .gradient-decoration {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
        }

        .decoration-1 {
          width: 400px;
          height: 400px;
          top: -100px;
          right: -100px;
          animation: float 20s ease-in-out infinite;
        }

        .decoration-2 {
          width: 300px;
          height: 300px;
          bottom: -80px;
          left: -80px;
          animation: float 15s ease-in-out infinite reverse;
        }

        .decoration-3 {
          width: 200px;
          height: 200px;
          top: 50%;
          left: 20%;
          animation: float 25s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -30px) scale(1.1);
          }
          66% {
            transform: translate(-30px, 30px) scale(0.9);
          }
        }

        /* Gradient Content */
        .gradient-text-content {
          position: relative;
          z-index: 2;
        }

        .welcome-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 24px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: white;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 32px;
        }

        .welcome-badge i {
          font-size: 18px;
        }

        .gradient-title {
          font-size: 52px;
          font-weight: 800;
          color: white;
          margin-bottom: 16px;
          line-height: 1.2;
          text-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        }

        .gradient-description {
          font-size: 22px;
          color: rgba(255, 255, 255, 0.95);
          margin-bottom: 48px;
        }

        /* Benefits */
        .benefit-list {
          display: flex;
          flex-direction: column;
          gap: 24px;
          margin-bottom: 48px;
          text-align: left;
        }

        .benefit-item {
          display: flex;
          align-items: flex-start;
          gap: 16px;
        }

        .benefit-icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 24px;
          flex-shrink: 0;
        }

        .benefit-text h4 {
          font-size: 18px;
          font-weight: 700;
          color: white;
          margin-bottom: 4px;
        }

        .benefit-text p {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.9);
          margin: 0;
        }

        /* Signup Illustration */
        .signup-illustration {
          width: 120px;
          height: 120px;
          margin: 0 auto;
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid rgba(255, 255, 255, 0.3);
          animation: pulse 3s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
          }
        }

        .signup-illustration i {
          font-size: 60px;
          color: white;
        }

        /* ============================================
           RESPONSIVE
        ============================================ */
        @media (max-width: 1024px) {
          .signup-right-panel {
            display: none;
          }

          .signup-left-panel {
            flex: 1;
          }
        }

        @media (max-width: 768px) {
          .modern-signup-page {
            min-height: calc(100vh - 60px);
          }

          .signup-left-panel {
            padding: 24px 16px;
          }

          .signup-form-container {
            max-width: 100%;
          }

          .signup-title {
            font-size: 28px;
          }

          .form-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
};

export default Signup;